import { Count } from '../../../../shared/components';
import { useBulkUploads } from '../../../../shared/context';

export const UploadsCount = () => {
  const {
    state: { totalCount },
  } = useBulkUploads();

  return (
    <Count
      title="Uploads"
      isLoading={false}
      noCount={totalCount === 0}
      count={totalCount}
    />
  );
};
